<template>
  <span
    class="help-block"
    v-if="currentError"
    v-html="currentError"
  ></span>
</template>

<script>
export default {
  name: 'ErrorHelpBlock',

  props: {
    currentError: {
      type: String,
      default: null
    },

    hasInputErrors: {
      type: Boolean,
      default: false
    }
  }
}
</script>
